export const getCancelDialogContentStyles = (_, { palette = {} }) => ({
  couponContainer: {
    display: 'flex',
    marginTop: 30,
  },
  couponIcon: {
    color: palette.themePrimary,
    marginRight: 5,
    fontSize: 16,
    fontStyle: 'normal',
    fontFamily: 'MsAds MDL2 Assets',
  },
  couponContent: {
    margin: '0 !important',
  },
  couponText: {
    marginBottom: '10px !important',
  },
  couponPlatform: {
    margin: '0 !important',
    fontSize: 12,
  },
});
